import { Minus, Plus } from 'lucide-react'

interface OmpQuantityStepperProps {
  value: number
  onChange: (value: number) => void
  min?: number
  // Without a max the + button never disables, as in the add-product drawer.
  max?: number
  label?: string
  disabled?: boolean
}

// OMP's quantity stepper (`.omp-qty`, styled in drawers.css), shared by the add-product drawer and
// the cross-sell popups.
const OmpQuantityStepper = ({ value, onChange, min = 1, max, label, disabled }: OmpQuantityStepperProps) => {
  const atMax = max != null && value >= max
  return (
    <div className="omp-qty" {...(label ? { role: 'group', 'aria-label': label } : {})}>
      <button
        type="button"
        onClick={() => onChange(Math.max(min, value - 1))}
        aria-label="Decrease"
        disabled={disabled}>
        <Minus size={18} />
      </button>
      <span className="omp-qty-value">{value}</span>
      <button type="button" onClick={() => onChange(value + 1)} aria-label="Increase" disabled={disabled || atMax}>
        <Plus size={18} />
      </button>
    </div>
  )
}

export default OmpQuantityStepper
